import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';

import PageLoading from './components/icons/PageLoading';
import { loadThemeSheets } from './theme';
import './styles/globals.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// False in staging and production, so Devtools and ?theme= drop out of those bundles.
const devEnvironment = import.meta.env.DEV || import.meta.env.VITE_ENVIRONMENT === 'development';
const app = import('./App');
const App = lazy(() => app);
const Devtools = devEnvironment ? lazy(() => import('./devtools/Devtools')) : null;

const start = async () => {
  await loadThemeSheets();
  if (devEnvironment) {
    const { applyThemeQuery } = await import('./devtools/themeQuery');
    await applyThemeQuery();
  }

  createRoot(rootElement).render(
    <StrictMode>
      <Suspense fallback={<PageLoading />}>
        <App />
      </Suspense>
      {Devtools ? (
        <Suspense fallback={null}>
          <Devtools />
        </Suspense>
      ) : null}
    </StrictMode>,
  );
};

void start();
